import { render } from "./MenuBreadcrumbsContainer.vue?vue&type=template&id=453f6593"
import script from "./MenuBreadcrumbsContainer.vue?vue&type=script&lang=js"
export * from "./MenuBreadcrumbsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__